import { createFileRoute } from "@tanstack/react-router";

import Targets from "@/components/Targets/Targets";

const Component = () => {
  const { climbType } = Route.useParams();
  if (climbType !== "BOULDER" && climbType !== "SPORT") {
    throw new Error("Invalid climb type");
  }
  return <Targets climbType={climbType} />;
};

export const Route = createFileRoute("/gym/$venueUuid/settings/targets/$climbType")({
  component: Component,
  parseParams: (params) => {
    return {
      climbType: params.climbType.toUpperCase(),
    };
  },
  stringifyParams: (params) => {
    return {
      climbType: params.climbType.toLowerCase(),
    };
  },
});
